// Phase-A R5 — Brand panel for the redesigned login (lg+ only).
// S-NRI-1 redesign (owner directive, 2026-07-22): LIGHT FORMAL institutional
// panel — no dark navy backdrop, no auroras/graph decoration, and strictly
// NO overlap between logos and text (the old absolutely-positioned centered
// mark collided with the headline). Layout is a simple centered column in
// official-letterhead order: the Ministry of Energy emblem LARGE on top with
// its title beneath it, then the NRI (پژوهشگاه نیرو) emblem as the operating
// institute, then the platform title and the honest stats row.
// Visible only at >720px; hidden entirely on phone via the .r5-login-shell
// responsive CSS.
import React from "react";

const ink = "#0b2447";
const muted = "#4a5a76";
const hairline = "1px solid rgba(11, 36, 71, 0.10)";

const StatRow: React.FC = () => {
  const stats: Array<{ v: string; l: string }> = [
    { v: "۵", l: "هلدینگ وزارت نیرو" },
    { v: "۱۸۰~", l: "شرکت زیرمجموعه" },
    { v: "۱۷۶K", l: "کارمند صنعت · دامنهٔ هدف" },
  ];
  return (
    <div
      style={{
        marginTop: 26,
        display: "flex",
        gap: 28,
        flexWrap: "wrap",
        justifyContent: "center",
        paddingTop: 18,
        borderTop: hairline,
      }}
    >
      {stats.map((s) => (
        <div key={s.l} style={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center" }}>
          <span style={{ fontSize: 22, fontWeight: 800, fontVariantNumeric: "tabular-nums", color: ink }}>{s.v}</span>
          <span style={{ fontSize: 11, color: muted, letterSpacing: "0.02em" }}>{s.l}</span>
        </div>
      ))}
    </div>
  );
};

export interface BrandPanelProps {
  /** Kept for call-site compatibility; the redesigned panel has no testimonial. */
  showTestimonial?: boolean;
}

export const BrandPanel: React.FC<BrandPanelProps> = () => (
  <aside
    className="r5-brand-panel"
    style={{
      position: "sticky",
      top: 0,
      alignSelf: "start",
      height: "100dvh",
      color: ink,
      background: "linear-gradient(180deg, #ffffff 0%, #f5f7fb 100%)",
      borderInlineStart: hairline,
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: "clamp(24px, 4vw, 56px)",
      gap: 0,
    }}
  >
    {/* — پژوهشگاه نیرو — تنها نشان صفحهٔ ورود (دستور مالک: لوگوی وزارت
        فقط در لندینگ رندر می‌شود). عنوان زیر نشان، الگوی رسمی. — */}
    <img
      src="/tenants/nri/pajooheshgah-512.webp"
      alt="پژوهشگاه نیرو"
      width="180"
      height="180"
      style={{ width: "clamp(130px, 14vw, 180px)", height: "auto", objectFit: "contain" }}
    />
    <div style={{ marginTop: 14, fontSize: 19, fontWeight: 800 }}>پژوهشگاه نیرو</div>
    <div style={{ marginTop: 3, fontSize: 12, color: muted }}>مجری سامانه · زیر نظر وزارت نیرو</div>

    {/* — عنوان سامانه — */}
    <h2
      style={{
        margin: "30px 0 0",
        maxWidth: "26ch",
        fontSize: "clamp(19px, 1.8vw, 24px)",
        lineHeight: 1.6,
        fontWeight: 800,
        color: ink,
      }}
    >
      سامانهٔ هوشمند آموزش ضمن خدمت صنعت آب و برق
    </h2>
    <p style={{ margin: "10px 0 0", maxWidth: "42ch", fontSize: 13, lineHeight: 1.9, color: muted }}>
      آموزش ضمن خدمت کارکنان صنعت آب و برق — با دستیارهای هوشمند تخصصی و
      گواهی ساعت‌محورِ قابل‌راستی‌آزمایی.
    </p>

    <StatRow />
  </aside>
);

export default BrandPanel;
